import { IUser } from "./../models/user.model";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { AuthService } from "../_services/auth.service";
import { RoleService } from "../_services/role.service";
import { ActivatedRoute } from "@angular/router";
import { User } from "../models/user.model";
import { Role } from "../models/role.model";
import { UserService } from "../_services/user.service";
import { Ng2ImgMaxService } from "ng2-img-max";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-user",
  templateUrl: "./userUpdate.component.html",
  styleUrls: ["./userUpdate.component.css"],
})
export class UserUpdateComponent implements OnInit {
  form: any = {};
  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = "";
  user: User;
  items = ["Admin", "Modérateur"];
  selected: any;
  update = false;
  roles: Role[];
  uploadedImage: File;
  uploadedImage2: String;
  imagePreview2: string;
  photo: any;
  photoUpdate: any;
  avatar = "assets/img/avatars/user.png";
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    private roleService: RoleService,
    private route: ActivatedRoute,
    private ng2ImgMax: Ng2ImgMaxService,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.user = new User();
    if (this.route.snapshot.paramMap.get("id")) {
      this.loadRoles();
      this.update = true;
      this.userService
        .getOne(this.route.snapshot.paramMap.get("id"))
        .subscribe((data: any) => {
          console.log(data);
          this.user = data;
          this.user.role = [];
          for (let r of this.user.roles) {
            if (r.name == "ROLE_ADMIN") {
              this.user.role.push("Admin");
            } else if (r.name == "ROLE_MODERATOR") {
              this.user.role.push("Modérateur");
            }
          }
          //console.log("Photo", this.user.photo);
          this.photoUpdate = this.user.photo;
          this.updateForm(this.user);
        });
    }

  }
  getValues() {
    console.log("Select roles", this.form.roles);
  }

  loadRoles() {
    this.roleService.getAll().subscribe((data: User[]) => {
      this.roles = data;
      console.log("Roles", this.roles);
    });
  }

  updateForm(user: IUser): void {
    this.form.id = user.id;
    this.form.nom = user.nom;
    this.form.prenom = user.prenom;
    this.form.username = user.username;
    this.form.role = user.role;
    this.form.email = user.email;
    this.form.password = user.password;
    this.form.etat = user.etat;
    this.form.photo = user.photo;
    this.form.roles = user.roles;
  }

  onSubmit() {
    if (this.user.id != null) {
      console.log("Form", this.form);
      this.user = this.form;
      this.user.roles = [];

      for (let r of this.form.role) {
        if (r == "Admin") {
          for (let b of this.roles) {
            if (b.name == "ROLE_ADMIN") {
              this.user.roles.push(b);
            }
          }
        } else if (r == "Modérateur") {
          for (let b of this.roles) {
            if (b.name == "ROLE_MODERATOR") {
              this.user.roles.push(b);
            }
          }
        }
      }
      if (this.photo == null) {
        this.user.photo = this.photoUpdate;
      } else {
        this.user.photo = this.photo;
      }

      this.userService.update(this.user.id, this.user).subscribe((data) => {
        console.log("Updated man!!");
        //console.log(data);
        this.retour();
      });
    } else {
      this.form.etat = true;
      //console.log("Form", this.form);
      this.user = this.form;
      //this.user.photo = this.photo;
      console.log("User", this.user);
      console.log("Photo", this.photo);
      this.user.photo = this.photo;
      this.user.password = "passer";
      this.authService.register(this.user).subscribe(
        (data) => {
          console.log(data);
          this.retour();
          this.isSuccessful = true;
          this.isSignUpFailed = false;
        },
        (err) => {
          this.errorMessage = err.error.message;
          this.isSignUpFailed = true;
        }
      );
    }
  }

  retour() {
    window.history.back();
  }

  onImageChange(event) {
    let image = event.target.files[0];

    this.ng2ImgMax.resizeImage(image, 140, 140).subscribe(
      (result) => {
        this.uploadedImage = new File([result], result.name);
        //this.onImageChange2(this.uploadedImage);
        this.getImagePreview(this.uploadedImage);
        //this.getBase642(this.uploadedImage);
      },
      (error) => {
        console.log("😢 Oh no!", error);
      }
    );
  }
  getImagePreview(file: File) {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const imagePreview: string = reader.result as string;
      this.imagePreview2 = imagePreview;
      this.user.photo = imagePreview;
      this.photo = imagePreview;
      console.log("Image resize base64", reader.result);
      console.log("Image lenght", this.imagePreview2.length);
    };
  }
}
